import { createFileRoute } from "@tanstack/react-router";

import { draftView } from "../../../workspaces/worlds/draft-view";
import { LocalWorldDraftPage } from "../../../workspaces/worlds/pages/LocalWorldDraftsPage";

export const Route = createFileRoute(
  "/_console/p/$org/$project/build-worlds/drafts/$draftId",
)({
  validateSearch: draftView,
  component: WorldDraftRoute,
});

function WorldDraftRoute() {
  const { org, project, draftId } = Route.useParams();
  const view = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <LocalWorldDraftPage
      draftId={draftId}
      view={view}
      onViewChange={(search) => void navigate({ search })}
      onBack={() =>
        void navigate({
          to: view.sessionId
            ? "/p/$org/$project/simulate/sessions"
            : "/p/$org/$project/simulate",
          params: { org, project },
          search: {},
        })
      }
    />
  );
}
